import { Flex, Text } from "@chakra-ui/react";
import { Blockout } from "./types";

export function isDentistAbsent(blockout: Blockout): boolean {
  const kind = String((blockout as any)?.kind ?? "")
    .trim()
    .toLowerCase();
  if (kind === "dentist_absent" || kind === "absent") return true;
  const name = String(blockout?.name ?? "")
    .trim()
    .toLowerCase();
  return (
    name === "not attent" ||
    name === "not attend" ||
    name === "absent" ||
    name.includes("absent")
  );
}

export default function BlockoutEvent({ blockout }: { blockout: Blockout }) {
  const dentistAbsent = isDentistAbsent(blockout);
  const label =
    dentistAbsent && /not attent/i.test(String(blockout?.name ?? ""))
      ? "Absent"
      : blockout.name;

  return (
    <Flex
      bg={dentistAbsent ? "#64748b" : "#e2e8f0"}
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      px={1}
      borderRadius="4px"
      opacity={dentistAbsent ? 0.95 : 1}
    >
      <Text
        color={dentistAbsent ? "#f8fafc" : "#475569"}
        fontWeight="bold"
        fontSize="xs"
        textAlign="center"
        noOfLines={2}
      >
        {label}
      </Text>
    </Flex>
  );
}
